<app-loader></app-loader>
<div class="initiate-booking-model">
  <div class="initiate-heading">
    <h5>Register New User</h5>
    <img (click)="close()" src="assets/images/new-close.svg" alt="Close" />
  </div>

  <div class="parker-outer">
    <div class="parker-inner" *ngFor="let option of options" (click)="selectOption(option.value)">
      <div class="parker-text" [ngClass]="{ 'parker-hover': selectedOption === option.value }">
        <img [src]="selectedOption === option.value ? option.hoverIcon : option.icon" [alt]="option.label" />
        <h4>{{ option.label }}</h4>
      </div>
    </div>
  </div>

  <div  class="pakar-bodytext">
    <div class="information-icon">
     <h4 class="fill-error" *ngIf="accountErrorMsg">{{accountErrorMsg}}</h4>
      <h3><span>Fill information below to create account.</span><app-tooltip [tooltipMessage]="toolTipInfo"></app-tooltip></h3>
     
    </div>

  </div>
  <div class="register-body">
    <form [formGroup]="createUserForm">
      <div class="register-input">
        <div class="search-input">
          <label for="firstName">First Name <span class="custom-star">*</span></label>
          <input type="text" NoLeadingSpaceDirective pInputText placeholder="Enter First Name" formControlName="firstName" maxlength="50"
            (keydown)="preventFirstSpace($event)" (keydown.enter)="onSubmit()" />

            <div
            *ngIf="createUserForm.get('firstName')?.hasError('required')  && (createUserForm.get('firstName')?.dirty || createUserForm.get('firstName')?.touched)">
            <div class="validation-error"> This field is required*</div>
        </div>

        <div
            *ngIf="createUserForm.get('firstName')?.hasError('minlength')  && (createUserForm.get('firstName')?.dirty || createUserForm.get('firstName')?.touched)">
            <div *ngIf="!createUserForm.get('firstName')?.hasError('pattern')"
                class="validation-error">Minimum 3 letters are required*</div>
        </div>
        <div
            *ngIf="createUserForm.get('firstName')?.hasError('leadingSpace')  && (createUserForm.get('firstName')?.dirty || createUserForm.get('firstName')?.touched)">
            <div *ngIf="!createUserForm.get('firstName')?.hasError('pattern')"
                class="validation-error">First Name cannot start with a space.*</div>
        </div>

        <div
            *ngIf="createUserForm.get('firstName')?.hasError('pattern')  && (createUserForm.get('firstName')?.dirty || createUserForm.get('firstName')?.touched)">
            <div class="validation-error"> Please enter only characters*</div>
        </div>
        </div>
        <div class="search-input">
          <label for="lastName">Last Name <span class="custom-star" *ngIf="requiredLastNameAsterisk">*</span></label>
          <input type="text" NoLeadingSpaceDirective pInputText placeholder="Enter Last Name" formControlName="lastName" maxlength="50"
            (keydown)="preventFirstSpace($event)" (keydown.enter)="onSubmit()" />
         <div
            *ngIf="createUserForm.get('lastName')?.hasError('required')  && (createUserForm.get('lastName')?.dirty || createUserForm.get('lastName')?.touched)">
            <div class="validation-error"> This field is required*</div>
        </div>

        <div
            *ngIf="createUserForm.get('lastName')?.hasError('minlength')  && (createUserForm.get('lastName')?.dirty || createUserForm.get('lastName')?.touched)">
            <div *ngIf="!createUserForm.get('lastName')?.hasError('pattern')"
                class="validation-error">Minimum 3 letters are required*</div>
        </div>
        <div
            *ngIf="createUserForm.get('lastName')?.hasError('leadingSpace')  && (createUserForm.get('lastName')?.dirty || createUserForm.get('lastName')?.touched)">
            <div *ngIf="!createUserForm.get('lastName')?.hasError('pattern')"
                class="validation-error">Last Name cannot start with a space.*</div>
        </div>

        <div
            *ngIf="createUserForm.get('lastName')?.hasError('pattern')  && (createUserForm.get('lastName')?.dirty || createUserForm.get('lastName')?.touched)">
            <div class="validation-error"> Please enter only characters*</div>
        </div>
        </div>
      </div>
      <div class="register-input">
        <div class="search-input">
          <div class="driver-label drivermobile-number country-code">
            <label for="phone">Mobile Number <span class="custom-star">*</span></label>
            <div class="number-text">
              <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [selectFirstCountry]="false"
                [selectedCountryISO]="countryISO" [maxLength]="10" [phoneValidation]="true" 
                [separateDialCode]="separateDialCode" [numberFormat]="phoneNumberFormat.National" name="phone"
                formControlName="phone" customPlaceholder="Enter Mobile Number"
                >
              </ngx-intl-tel-input>
            </div>
            <div class="
                        error-outer">
              <div
                *ngIf="createUserForm.get('phone')?.hasError('required') && createUserForm.get('phone')?.dirty && createUserForm.get('phone')?.touched">
                <small class="validation-error">This field is required*</small>
              </div>
              <div
                *ngIf="!createUserForm.get('phone')?.hasError('required') && createUserForm.get('phone')?.touched && createUserForm.get('phone')?.invalid">
                <small class="validation-error">Mobile number is not valid*</small>
              </div>
            </div>
            </div>
        </div>
        <div class="search-input">
          <label for="email">Email <span class="custom-star">*</span></label>
          <input type="text" pInputText placeholder="Enter Email" formControlName="email" maxlength="50"
            (keydown)="preventFirstSpace($event)" (keydown.enter)="onSubmit()" />
            <div class="
            error-outer">
                <div
                    *ngIf="createUserForm.get('email')?.hasError('required')  && (createUserForm.get('email')?.dirty || createUserForm.get('email')?.touched)">
                    <div class="validation-error"> This field is required*</div>
                </div>
                <div
                    *ngIf="createUserForm.get('email')?.hasError('pattern')  && (createUserForm.get('email')?.dirty || createUserForm.get('email')?.touched)">
                    <div class="validation-error"> Please enter a valid email*</div>
                </div>
            </div>
        </div>
      </div>
   
      <div class="register-input" [ngClass]="{'create-parkername': !showInput}">
        <div class="search-input company-outer">
          <label for="groupName">Company Name <span class="custom-star">*</span></label>
          <input type="text" pInputText placeholder="Enter Company Name" formControlName="groupName" maxlength="50"
            (keydown)="preventFirstSpace($event)" (keydown.enter)="onSubmit()" />
            <div class="error-outer">
              <div *ngIf="
                            createUserForm.get('groupName')?.hasError('required') &&
                              (createUserForm.get('groupName')?.dirty ||
                              createUserForm.get('groupName')?.touched)
                            ">
                <div class="validation-error">This field is required*</div>
              </div>
            
              <div *ngIf="
                              createUserForm.get('groupName')?.hasError('minlength') &&
                              (createUserForm.get('groupName')?.dirty ||
                              createUserForm.get('groupName')?.touched)
                            ">
                <div *ngIf="
                                !createUserForm.get('groupName')?.hasError('leadingSpace')
                              " class="validation-error">
                  Min. 3 letters are required*
                </div>
              </div>
            
              <div *ngIf="
                              createUserForm.get('groupName')?.hasError('pattern') &&
                              (createUserForm.get('groupName')?.dirty ||
                              createUserForm.get('groupName')?.touched)
                            ">
                <div class="validation-error">
                  Please enter only characters*
                </div>
              </div>
            
              <div *ngIf="createUserForm.get('groupName').hasError('leadingSpace')" class="validation-error">
                Company Name cannot start with a space.</div>
            </div>
        </div>

      </div>

      <div class="save-btn">
        <p-button label="Confirm" (onClick)="onSubmit()"></p-button>
      </div>
      <p class="note-text"><span>Note: </span>On successful creation, {{ showInput ? 'Group Operator' : 'Parker' }} would receive login credentials via
        email/mobile number.</p>
    </form>
  </div>